<div [class.navigation-arrows]="navigationArrows" class="wrapper">
  <div
    data-at-year-datepicker-previous
    gtm="onChange"
    gtmAction="Previous Year"
    gtmCategory="Hems"
    [class.arrow-disabled]="!canSelectPreviousYear()"
    *ngIf="navigationArrows"
    (click)="onPreviousYear()"
    class="arrow arrow-left"
  >
    <mat-icon>chevron_left</mat-icon>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>{{ '+GENERAL.DATEPICKER.YEAR_PICKER' | translate }}</mat-label>
    <input
      data-at-year-datepicker
      matInput
      readonly
      fieldTextContentTooltip
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="datepicker"
      [formControl]="datepickerDate"
    />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker
      #datepicker
      startView="multi-year"
      (yearSelected)="onSelectYear($event, datepicker)"
      panelClass="year-datepicker"
    >
    </mat-datepicker>
  </mat-form-field>
  <div
    data-at-year-datepicker-next
    gtm="onChange"
    gtmAction="Next Year"
    gtmCategory="Hems"
    [class.arrow-disabled]="!canSelectNextYear()"
    *ngIf="navigationArrows"
    (click)="onNextYear()"
    class="arrow arrow-right"
  >
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
